import { combineReducers } from "redux";
import {
  CountrySettings,
  Localization,
  Tracking,
  RtlSupport,
  CanaryVersions,
  Utf,
  MicroFrontend,
} from "root/libs/ui-containers/src";
import {
  AB_TEST_STATE,
  abTestReducer,
} from "root/libs/ui-containers/src/lib/AbTest";
import getQuoteReducer from "../containers/GetQuote/reducer";
import shipmentLaneReducer from "../containers/ShipmentLane/reducer";
import offersLaneReducer from "../containers/OffersLane/reducer";
import tradeLaneReducer from "../containers/TradeLane/reducer";
import personalization from "../containers/Personalization/reducer";
import spotShipmentPage from "../containers/SpotShipmentPage/reducer";
import expressReducer from "../containers/Express/reducer";

const reducers = combineReducers({
  [AB_TEST_STATE]: abTestReducer,
  rtlSupport: RtlSupport.reducer,
  canaryVersion: CanaryVersions.reducer,
  countrySettings: CountrySettings.reducer,
  getQuote: getQuoteReducer,
  localization: Localization.reducer,
  offersLane: offersLaneReducer,
  personalization,
  shipmentLane: shipmentLaneReducer,
  spotShipmentPage,
  tracking: Tracking.reducer,
  tradeLane: tradeLaneReducer,
  utf: Utf.reducer,
  microFrontend: MicroFrontend.reducer,
  express: expressReducer,
});

export default reducers;
